import React, { ButtonHTMLAttributes } from "react";
import "./PulseButton.scss";

interface IProps extends ButtonHTMLAttributes<any> {
    delay?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
}

export function PulseButton({children, className, delay, ...props}: IProps) {
    return (
        <button
            className={`${className} pulse-button`}
            data-delay={delay}
            {...props}>
            {children}
            <span className={"pulse-ring"} />
            <span className={"pulse-ring"} />
            <span className={"pulse-ring"} />
        </button>
    )
}
